(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var track = document.querySelector('[data-ol-track]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-ol-thumb]'));
    if (track && thumbs.length) {
      var setActive = function (i) {
        thumbs.forEach(function (t, n) {
          if (n === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      };
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        });
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          setActive(Math.max(0, Math.min(thumbs.length - 1, i)));
          ticking = false;
        });
      });
    }

    var sticky = document.querySelector('[data-ol-sticky]');
    var mainCta = document.querySelector('[data-ol-cta]');
    var finalCta = document.querySelector('[data-ol-final]');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      var state = { main: true, final: false };
      var update = function () {
        sticky.classList.toggle('is-visible', !state.main && !state.final);
      };
      new IntersectionObserver(function (e) {
        state.main = e[0].isIntersecting;
        update();
      }).observe(mainCta);
      if (finalCta) {
        new IntersectionObserver(function (e) {
          state.final = e[0].isIntersecting;
          update();
        }).observe(finalCta);
      }
    }
  });
})();
